import './Home.css';

import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import github from '../../Assets/git-03.svg';
import Prueba from '../../components/prueba/prueba';
import linkedin from '../../Assets/in-03.svg';
import cv from '../../Assets/c-03.svg';
import { Col, Container,  Row, Image } from 'react-bootstrap';
import Works from '../Works/Works';
import About from '../About/About';
import { motion } from 'framer-motion';
import Footer from '../../components/Footer/Footer';
import cvEn from '../../Assets/cv-en.pdf';
import cvEs from '../../Assets/cv-es.pdf';

import { useTranslation } from 'react-i18next';




const Home = ({title}) => {
    const downloadCV = () => {
        const lang = i18n.language === 'es' ? 'es' : 'en';
        const cvFile = lang === 'es' ? cvEs : cvEn;
        const link = document.createElement('a');
        link.href = cvFile;
        link.target = '_blank';
        link.download = `cv-${lang}.pdf`;
        link.click();
      };

    const scrollToSection = () => {
        const seccionDestino = document.getElementById('Works');
        if (seccionDestino) {
          seccionDestino.scrollIntoView({ behavior: 'smooth' });
        }}




      const { t, i18n } = useTranslation();
      const [language, setLanguage] = useState('en');
        const changeLanguage = (language) => {
          i18n.changeLanguage(language);
          setLanguage(language);
        };
      

    return (

        <Container >
          <Prueba />
            <Row id='home' className='sectionHello' xxl={12} xl={12} lg={12} md={12} >
            <Col xxl={12} className='initial'>
                <Row className='presentation'>
                    <motion.div className='saludoDos' animate={{ y: -20}} transition={{ duration: 1 }}>
                        <Col className='titulosHell'>
                            <h1 className='subtitleTwo'>{t("Hello! I'm Belu")}</h1>
                            <h2 className='hello'>{t('Frontend Developer')}  </h2>
                        </Col>
                    </motion.div>

                    <Col className='initialPersona'>
                <motion.div 
                initial={{ scale: 0}} 
                transition={{ duration: 1 }}
                animate={{ scale: 1}}
                className='redesOrden'>
                    <NavLink className='redes' to={"https://www.linkedin.com/in/mariabelencaporale/"} target="_blanck">
                        <Image src={linkedin} className='redH' />
                    </NavLink>

                    

                    <NavLink className='redes' to={"https://github.com/MariaBelenCaporale"} target="_blanck">                    
                        <Image src={github} className='redH' />
                    </NavLink>

                    <NavLink className='redes'>
                      
                        <Image src={cv} onClick={downloadCV} className='redH' />
                      
                    </NavLink>

                </motion.div>
            </Col>
                </Row>
            </Col>
            </Row>

        <Works />

            <Col  className='ab'>
        <About/>
        </Col>
        <Footer />

        </Container>


    )
};

export default Home;